<ng-container [formGroup]="form">
	<tvcore-select [options]="subsidyTypes" key="type" name="subsidyType">
		<ng-template #optionTemplate let-option>
			{{ option.name || getSubsidyConfig(option.type)?.name }}
		</ng-template>
	</tvcore-select>
</ng-container>
